module.exports = __webpack_public_path__ + "static/media/love.bf9aa62d.png";